export default "__VITE_ASSET__fa156123__"